module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "row expanded small-up-2 medium-up-3 large-up-4"
  }, _vm._l((_vm.countriesList), function(countries, index) {
    return _c('li', {
      staticClass: "column column-block",
      attrs: {
        "value": countries.name
      }
    }, [_c('a', {
      attrs: {
        "target": "_blank",
        "href": countries.wwfurl + '/?referer=wwfau'
      }
    }, [_vm._v("\n        " + _vm._s(countries.name) + "\n      ")])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07d6ba03","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=8hbdlddx288!./~/string-replace-webpack-plugin/loader.js?id=ayyc1bnkec!./src/components/wwfCountryList.vue
// module id = 392
// module chunks = 1